// NOTE: shape coupled to that of the sanity margins fragment
export const sanityMarginToScss = (sanityMargins) => {
  const {top, bottom} = sanityMargins ?? {};

  return {
    marginTop: `${top ?? 3}rem`,
    marginBottom: `${bottom ?? 3}rem`,
  };
};
